module.exports = __webpack_public_path__ + "static/media/1011091.b76784fe.jpg";